module.exports = __webpack_public_path__ + "img/emurgo.250e8585.svg";